/* Popup „Reducere surpriză" — SeveShop (sections/surprise-popup.liquid) */
(() => {
  const DAY = 864e5;
  const now = () => Date.now();
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const track = (name, data) => {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('osm_' + name, data || {}); } catch (e) {}
    try { window.dataLayer && window.dataLayer.push(Object.assign({ event: 'osm_' + name }, data || {})); } catch (e) {}
  };

  function init(root) {
    if (!root || root.__osm) return;
    root.__osm = true;

    const d = root.dataset;
    const sid = d.sectionId;
    const design = d.design === 'true';
    const test = d.test === 'true';
    const timerTotal = parseInt(d.timer, 10) || 0;
    const freqMs = (parseInt(d.freq, 10) || 3) * DAY;
    let code = ''; // doar codul personal, primit de la Worker după pasul cu telefonul
    const prefix = 'osm:' + (d.campaign || 'v1') + ':';

    const store = {
      get(k) { try { return localStorage.getItem(prefix + k); } catch (e) { return null; } },
      set(k, v) { if (design) return; try { localStorage.setItem(prefix + k, String(v)); } catch (e) {} },
      del(k) { try { localStorage.removeItem(prefix + k); } catch (e) {} }
    };
    const until = (k) => parseInt(store.get(k), 10) || 0;
    // Abonat deja (independent de campanie): nu mai arătăm popup-ul deloc.
    const SUB_KEY = 'osm:subscriber';
    const isSubscriber = () => { try { return localStorage.getItem(SUB_KEY) === '1'; } catch (e) { return false; } };
    const markSubscriber = () => { if (design) return; try { localStorage.setItem(SUB_KEY, '1'); } catch (e) {} };

    const panel = root.querySelector('.osm__panel');
    const steps = root.querySelectorAll('[data-osm-step]');
    const timerEl = root.querySelector('[data-osm-timer]');
    const form = root.querySelector('[data-osm-form]');
    const email = form && form.querySelector('input[type="email"]');
    const consent = form && form.querySelector('[data-osm-consent]');
    const tagsInput = form && form.querySelector('[data-osm-tags]');
    const errorEl = root.querySelector('[data-osm-error]');
    const submitBtn = root.querySelector('[data-osm-submit]');
    const valueEl = root.querySelector('[data-osm-value]');
    const cta = root.querySelector('[data-osm-cta]');
    const copyBtn = root.querySelector('[data-osm-copy]');
    const teaser = document.querySelector('[data-osm-teaser="' + sid + '"]');
    const titleMain = root.querySelector('[data-osm-title]');
    const titleSms = root.querySelector('[data-osm-title-sms]');
    const hasSms = d.sms === 'true' && !!root.querySelector('[data-osm-step="sms"]');
    const smsForm = root.querySelector('[data-osm-sms-form]');
    const phoneInput = root.querySelector('[data-osm-phone]');
    const ccSelect = root.querySelector('[data-osm-cc]');
    const smsConsent = root.querySelector('[data-osm-sms-consent]');
    const smsError = root.querySelector('[data-osm-sms-error]');
    const smsSubmit = root.querySelector('[data-osm-sms-submit]');
    let lastEmail = '';
    let openedAt = 0;
    const hp = root.querySelector('[data-osm-hp]');

    let current = 'question';
    let answer = store.get('answer') || '';
    let isOpen = false;
    let tickId = null;
    let lastFocus = null;
    let autoShown = false;

    // Link-ul final: /discount/COD?redirect=... aplică reducerea în coș
    const redirect = (() => {
      try { const u = new URL(d.redirect || '/', location.origin); return u.pathname + u.search; } catch (e) { return '/'; }
    })();
    const giftMode = d.reward === 'gift' && !!root.querySelector('[data-osm-step="game"]');
    const finalStep = giftMode ? 'game' : 'reveal';
    const firstStep = 'question';
    // modul cadou: întrebare → cărți (alege una, rămâne „?”) → email → telefon → cartea se întoarce cu premiul
    const afterAnswer = giftMode ? 'game' : 'email';
    const setCta = () => root.querySelectorAll('[data-osm-cta]').forEach((a) => { a.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect) : redirect; });
    // Codul personal (unic per abonat): afișat, copiat și aplicat în locul celui comun.
    // Codul personal se aplică singur în coș (cookie-ul de reducere Shopify), ca să nu depindă de copiere.
    const applyCode = (c) => {
      if (!c || design) return;
      const mark = () => {
        if (root.querySelector('.osm__applied')) return;
        const scopeEl = root.querySelector('[data-osm-step="' + finalStep + '"]') || root;
        const box = scopeEl.querySelector('[data-osm-copy]') || scopeEl.querySelector('[data-osm-value]');
        if (!box) return;
        const p = document.createElement('p');
        p.className = 'osm__note osm__applied';
        p.textContent = '✓ Codul e deja aplicat în coșul tău.';
        box.insertAdjacentElement('afterend', p);
      };
      if (store.get('applied') === c) { mark(); return; }
      fetch('/discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
        .then((r) => { if (r.ok) { store.set('applied', c); mark(); track('code_applied', { code: c }); } })
        .catch(() => {});
    };
    const useCode = (c) => {
      if (!c) return;
      code = c;
      store.set('code', c);
      if (giftMode) store.set('prize_code', c);
      root.querySelectorAll('.osm__code-txt').forEach((t) => { t.textContent = c; });
      root.querySelectorAll('[data-osm-copy]').forEach((b) => { b.hidden = false; });
      root.querySelectorAll('[data-osm-pending]').forEach((p) => { p.hidden = true; });
      setCta();
      applyCode(c);
    };

    /* ---------- Modul „cadou”: 4 cărți ----------
       Premiul vine de la Worker (tras la sorți pe server, o dată per email); cartea aleasă doar îl dezvăluie.
       Amestecarea e rapidă tocmai ca alegerea să fie „oarbă” și să nu sugereze că poți urmări o carte anume. */
    let prizeKey = store.get('prize') || '';
    let gameStarted = false;
    let picked = false;
    // ordinea: întâi jocul (cărțile, clientul alege una) → email → telefon → abia apoi se întoarce cartea aleasă cu premiul
    let gamePhase = 'play';
    let chosen = null;
    const cardsEl = root.querySelector('[data-osm-cards]');
    const gameHint = root.querySelector('[data-osm-game-hint]');
    // salvăm cadoul și pentru coș (osm-gift-cart.js): varianta, numele și codul
    const setPrize = (p) => {
      if (!p || !p.key) return;
      prizeKey = p.key; store.set('prize', p.key);
      const src = cardsEl && cardsEl.querySelector('[data-osm-card][data-key="' + p.key + '"]');
      if (src) { store.set('prize_variant', src.dataset.variant || ''); store.set('prize_title', src.dataset.title || ''); }
    };
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));
    const shuffleOnce = () => {
      const cards = [...cardsEl.children];
      const first = cards.map((c) => c.getBoundingClientRect());
      let order = cards.slice();
      for (let i = order.length - 1; i > 0; i--) { const j = crypto.getRandomValues(new Uint32Array(1))[0] % (i + 1); [order[i], order[j]] = [order[j], order[i]]; }
      if (order.every((c, i) => c === cards[i])) order.push(order.shift());
      order.forEach((c) => cardsEl.appendChild(c));
      cards.forEach((c, i) => {
        const last = c.getBoundingClientRect();
        c.style.transition = 'none';
        c.style.transform = 'translate(' + (first[i].left - last.left) + 'px,' + (first[i].top - last.top) + 'px)';
      });
      void cardsEl.offsetWidth;
      cards.forEach((c) => { c.style.transition = 'transform .2s ease-in-out'; c.style.transform = ''; });
    };
    async function startGame() {
      if (gameStarted || !cardsEl) return;
      gameStarted = true;
      const cards = [...cardsEl.children];
      if (design) return;
      if (gameHint) gameHint.textContent = gameHint.dataset.watch || '';
      await wait(1900);
      cards.forEach((c) => c.classList.remove('is-front'));
      await wait(550);
      for (let i = 0; i < 5; i++) { shuffleOnce(); await wait(230); }
      cards.forEach((c) => { c.disabled = false; });
      if (gameHint) gameHint.textContent = gameHint.dataset.pick || '';
      cardsEl.classList.add('is-ready');
    }
    async function pickCard(card) {
      if (picked) return;
      picked = true;
      chosen = card;
      cardsEl.classList.remove('is-ready');
      [...cardsEl.children].forEach((c) => { c.disabled = true; if (c !== card) c.classList.add('is-dim'); });
      card.classList.add('is-picked');
      track('pick');
      if (gameHint) gameHint.textContent = gameHint.dataset.after || '';
      await wait(1300);
      show('email');
    }
    // după telefon: cartea aleasă se întoarce și arată premiul tras pe server
    async function revealPrize() {
      if (!cardsEl) return;
      const card = chosen || cardsEl.querySelector('[data-osm-card]');
      if (!card || card.classList.contains('is-front')) return;
      [...cardsEl.children].forEach((c) => { c.disabled = true; if (c !== card) c.classList.add('is-dim'); });
      card.classList.add('is-picked');
      if (gameHint) gameHint.textContent = gameHint.dataset.reveal || '';
      for (let i = 0; i < 40 && !prizeKey; i++) await wait(250); // premiul poate întârzia o clipă
      const src = prizeKey && cardsEl.querySelector('[data-osm-card][data-key="' + prizeKey + '"]');
      const title = src ? src.dataset.title : '';
      if (src && src !== card) {
        const img = card.querySelector('[data-osm-card-img]'), simg = src.querySelector('[data-osm-card-img]');
        if (img && simg) img.src = simg.src;
        const t = card.querySelector('[data-osm-card-title]'); if (t) t.textContent = title;
      }
      await wait(400);
      card.classList.add('is-front');
      track('gift', { prize: prizeKey });
      await wait(600);
      const res = root.querySelector('[data-osm-game-result]');
      const win = root.querySelector('[data-osm-game-win]');
      if (win) win.textContent = prizeKey ? (win.dataset.text || '').replace('[cadou]', title) : 'Cadoul tău se pregătește — reîncarcă pagina peste câteva secunde.';
      if (gameHint) gameHint.hidden = true;
      if (res) res.hidden = false;
      store.set('seen', 1);
    }
    if (cardsEl) cardsEl.addEventListener('click', (e) => { const c = e.target.closest('[data-osm-card]'); if (c && !c.disabled) pickCard(c); });
    setCta();
    if (!design && store.get('code')) useCode(store.get('code'));

    /* ---------- Cronometru (curge doar cât e deschis) ---------- */
    const elapsed = () => parseInt(store.get('elapsed'), 10) || 0;
    const fmt = (s) => Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
    const renderTimer = (left) => {
      if (!timerEl) return;
      timerEl.textContent = fmt(Math.max(0, left));
      timerEl.classList.toggle('is-low', left <= 10 && left > 0);
    };
    const stopTimer = () => { clearInterval(tickId); tickId = null; };
    const startTimer = () => {
      if (!timerTotal || design || tickId || current === 'reveal' || current === 'expired') return;
      // la fiecare deschidere timerul pornește de la valoarea întreagă (ex. 1:00), nu de unde rămăsese
      let e = 0;
      store.del('elapsed');
      renderTimer(timerTotal - e);
      tickId = setInterval(() => {
        e += 1;
        store.set('elapsed', e);
        renderTimer(timerTotal - e);
        if (e >= timerTotal) expire();
      }, 1000);
    };
    // O singură cerere theMarketer per abonat: dacă nu dă telefonul, anunțăm Worker-ul să trimită doar emailul.
    let emailOnlySent = false;
    const finalizeEmailOnly = () => {
      if (emailOnlySent || design || !hasSms || !d.smsUrl) return;
      const addr = lastEmail || store.get('email');
      if (!addr || !store.get('done')) return;
      emailOnlySent = true;
      fetch(d.smsUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', keepalive: true, body: JSON.stringify({ email: addr }) }).catch(() => {});
    };
    const expire = () => {
      if (current === 'sms') finalizeEmailOnly();
      stopTimer();
      if (timerEl) timerEl.hidden = true;
      show('expired');
      store.set('expired_until', now() + freqMs);
      store.del('elapsed');
      track('expired');
      setTimeout(() => close('expired'), 2600);
    };

    /* ---------- Pași ---------- */
    function show(step) {
      current = step;
      steps.forEach((el) => { el.hidden = el.dataset.osmStep !== step; });
      const gameEnd = step === 'game' && gamePhase === 'reveal';
      root.classList.toggle('is-done', step === 'reveal' || gameEnd || step === 'expired' || step === 'already');
      root.classList.toggle('is-step-game', step === 'game' && !gameEnd);
      root.classList.toggle('is-step-sms', step === 'sms');
      if (titleSms) { titleSms.hidden = step !== 'sms'; if (titleMain) titleMain.hidden = step === 'sms'; }
      if (step === 'sms' && phoneInput && !design) setTimeout(() => { try { phoneInput.focus({ preventScroll: true }); } catch (e) {} }, 60);
      if (timerEl) timerEl.hidden = step === 'reveal' || gameEnd || step === 'expired' || step === 'already';
      if (step === 'game') { if (gameEnd) { stopTimer(); revealPrize(); } else if (picked) { show('email'); return; } else startGame(); }
      if (step === 'already') stopTimer();
      if (step === 'reveal') { stopTimer(); roll(); store.set('seen', 1); }
      if (step === 'email' && email && !design) setTimeout(() => { try { email.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }

    function roll() {
      if (!valueEl) return;
      const final = valueEl.dataset.final || valueEl.textContent;
      const m = final.match(/(\d+)/);
      if (!m || design || matchMedia('(prefers-reduced-motion: reduce)').matches) { valueEl.textContent = final; return; }
      const target = parseInt(m[1], 10);
      const pool = [5, 15, 25, 7, 20, 12, 30, 8, 18].filter((n) => n !== target);
      let i = 0;
      valueEl.classList.add('is-rolling');
      const step = () => {
        if (i < 14) {
          valueEl.textContent = final.replace(m[1], pool[i % pool.length]);
          i += 1;
          setTimeout(step, 50 + i * 12);
        } else {
          valueEl.textContent = final;
          valueEl.classList.remove('is-rolling');
          valueEl.classList.add('is-done');
        }
      };
      step();
    }

    /* ---------- Deschidere / închidere ---------- */
    function open(step, how) {
      if (isOpen) { show(step || current); return; }
      isOpen = true;
      if (!openedAt) openedAt = now();
      lastFocus = document.activeElement;
      root.hidden = false;
      if (teaser) teaser.hidden = true;
      show(step || current);
      document.documentElement.classList.add('osm-lock');
      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
      startTimer();
      if (!design) {
        const f = root.querySelector('[data-osm-step]:not([hidden]) button, [data-osm-step]:not([hidden]) input');
        setTimeout(() => { try { (f || panel).focus({ preventScroll: true }); } catch (e) {} }, 80);
        track('open', { how: how || 'auto', step: current });
      }
    }

    function close(reason) {
      if (!isOpen) return;
      isOpen = false;
      stopTimer();
      root.classList.remove('is-open');
      document.documentElement.classList.remove('osm-lock');
      setTimeout(() => { if (!isOpen) root.hidden = true; }, 360);
      if (design) return;
      if (reason === 'user' && current !== 'reveal') {
        store.set('closed_until', now() + freqMs);
        track('close', { step: current });
      }
      refreshTeaser();
      try { lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }

    function refreshTeaser() {
      if (!teaser || design) return;
      if (store.get('done')) { teaser.hidden = true; return; }
      const blocked = store.get('done') || isSubscriber() || until('expired_until') > now();
      teaser.hidden = !!(blocked || isOpen || until('closed_until') <= now());
    }

    /* ---------- Evenimente ---------- */
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-osm-close]')) {
        e.preventDefault();
        if (current === 'sms') { track('sms_skip', { how: 'close' }); store.set('seen', 1); finalizeEmailOnly(); }
        close('user');
        return;
      }
      if (e.target.closest('[data-osm-sms-skip]')) { track('sms_skip', { how: 'link' }); show('reveal'); return; }

      const ans = e.target.closest('[data-osm-answer]');
      if (ans) {
        answer = ans.dataset.osmAnswer || '';
        store.set('answer', answer);
        root.querySelectorAll('[data-osm-answer]').forEach((b) => b.classList.toggle('is-picked', b === ans));
        track('answer', { answer });
        setTimeout(() => show(afterAnswer), 220);
        return;
      }

      const copyEl = e.target.closest('[data-osm-copy]');
      if (copyEl) {
        const lbl = copyEl.querySelector('[data-osm-copy-label]');
        const orig = lbl ? lbl.textContent : '';
        const done = () => { if (lbl) { lbl.textContent = 'Copiat!'; setTimeout(() => { lbl.textContent = orig; }, 1800); } };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
        return;
      }

      if (e.target.closest('[data-osm-cta]')) track('cta', { code });
    });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { if (current === 'sms') { store.set('seen', 1); finalizeEmailOnly(); } close('user'); return; }
      if (e.key !== 'Tab') return;
      const f = [...panel.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])')].filter((el) => !el.closest('[hidden]') && el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (teaser) {
      teaser.addEventListener('pointerenter', () => root.querySelectorAll('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; }), { once: true });
      teaser.addEventListener('click', () => open(store.get('done') ? 'reveal' : current, 'teaser'));
    }

    /* ---------- Trimiterea emailului (formularul nativ de client Shopify) ---------- */
    const setError = (msg) => { if (!errorEl) return; errorEl.textContent = msg || ''; errorEl.hidden = !msg; };

    // Tagurile (interes-*) ajung în theMarketer prin Worker-ul din spatele app proxy-ului (citește clientul din Shopify).
    const syncMarketer = (addr) => {
      if (!addr || !d.syncUrl) return;
      fetch(d.syncUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: addr }), keepalive: true, credentials: 'same-origin' })
        .then((r) => r.json()).then((j) => track('sync', { ok: !!(j && j.ok), error: j && j.error })).catch(() => {});
    };

    const success = (viaWorker, personalCode) => {
      useCode(personalCode);
      lastEmail = (email && email.value.trim()) || store.get('email') || '';
      if (!viaWorker) syncMarketer(lastEmail);
      store.del('email');
      store.set('done', 1);
      markSubscriber();
      store.del('elapsed');
      store.del('pending');
      track('subscribe', { answer });
      show(hasSms ? 'sms' : 'reveal');
      refreshTeaser();
    };

    if (form) form.addEventListener('submit', (e) => {
      // A doua trecere (fallback): lăsăm fluxul nativ Shopify (cu protecția lui anti-spam) să trimită formularul.
      if (form.__osmNative) { store.set('pending', now()); store.set('email', (email.value || '').trim()); return; }
      // Altfel oprim tot: protecția Shopify ascultă pe document și ar trimite formularul chiar și invalid.
      e.preventDefault();
      e.stopImmediatePropagation();
      if (design) { show('reveal'); return; }
      setError('');
      const val = (email.value || '').trim();
      email.classList.toggle('is-invalid', !EMAIL_RE.test(val));
      if (!EMAIL_RE.test(val)) { setError('Te rugăm să introduci o adresă de email validă.'); email.focus(); return; }
      if (d.consent === 'true' && consent && !consent.checked) {
        consent.closest('.osm__consent').classList.add('is-invalid');
        setError('Bifează acordul ca să-ți trimitem reducerea.');
        return;
      }
      if (consent) consent.closest('.osm__consent').classList.remove('is-invalid');

      const base = (d.baseTags || '').split(',').map((t) => t.trim()).filter(Boolean);
      if (answer) base.push('interes-' + answer);
      if (tagsInput) tagsInput.value = base.join(', ');
      email.value = val;

      submitBtn.disabled = true;
      const native = () => {
        // La întoarcere (?customer_posted=true) popup-ul se redeschide direct pe pasul cu codul.
        form.__osmNative = true;
        submitBtn.disabled = false;
        if (form.requestSubmit) form.requestSubmit(submitBtn);
        else { store.set('pending', now()); store.set('email', email.value); HTMLFormElement.prototype.submit.call(form); }
      };

      // 1) Abonare prin Worker (fără captcha, cu protecția noastră). 2) Rezervă: formularul nativ Shopify.
      const viaShopify = () => fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then((res) => {
          if (res.ok && /customer_posted=true/.test(res.url)) return success();
          if (!res.ok || /\/challenge/.test(res.url)) return native();
          return res.text().then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const err = doc.querySelector('#osm-form .errors, #osm-form .form-message--error');
            if (err && err.textContent.trim()) { submitBtn.disabled = false; setError('Adresa nu a putut fi salvată. Verifică emailul și încearcă din nou.'); return; }
            native();
          });
        })
        .catch(native);

      if (!d.subscribeUrl) { viaShopify(); return; }
      fetch(d.subscribeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: val, answer, consent: true, consentMode: consent ? (consent.defaultChecked ? 'precheck' : 'checkbox') : 'button', hp: hp ? hp.value : '', t: now() - (openedAt || now()), page: location.pathname, newOnly: d.newOnly === 'true', defer: hasSms }),
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))))
        .then((j) => {
          if (j && j.ok) { success(true, j.code); return; }
          const err = j && j.error;
          if (err === 'already_subscribed') { submitBtn.disabled = false; markSubscriber(); track('already', {}); show('already'); refreshTeaser(); return; }
          if (err === 'bad_email') { submitBtn.disabled = false; setError('Adresa de email nu pare validă. Verifică și încearcă din nou.'); return; }
          if (err === 'rate_limited') { submitBtn.disabled = false; setError('Prea multe încercări. Te rugăm să revii în câteva minute.'); return; }
          viaShopify();
        })
        .catch(viaShopify);
    });

    /* ---------- Pasul SMS (telefon) → Worker: acord SMS în Shopify + canal sms în theMarketer ---------- */
    const normPhone = (cc, raw) => {
      let v = String(raw || '').replace(/[^\d+]/g, '');
      if (v.startsWith('00')) v = '+' + v.slice(2);
      if (!v.startsWith('+')) v = cc + v.replace(/^0+/, '');
      return v;
    };
    const smsErr = (msg) => { if (!smsError) return; smsError.textContent = msg || ''; smsError.hidden = !msg; };

    if (smsForm) smsForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (design) { show('reveal'); return; }
      smsErr('');
      const cc = (ccSelect && ccSelect.value) || '+40';
      const phone = normPhone(cc, phoneInput.value);
      const ok = cc === '+40' ? /^\+407\d{8}$/.test(phone) : /^\+[1-9]\d{7,14}$/.test(phone);
      phoneInput.closest('.osm__phone').classList.toggle('is-invalid', !ok);
      if (!ok) { smsErr(cc === '+40' ? 'Introdu un număr de mobil valid (ex. 0722 123 456).' : 'Introdu un număr de telefon valid.'); phoneInput.focus(); return; }
      if (smsConsent && !smsConsent.checked) {
        smsConsent.closest('.osm__consent').classList.add('is-invalid');
        smsErr('Bifează acordul pentru SMS.');
        return;
      }
      if (smsConsent) smsConsent.closest('.osm__consent').classList.remove('is-invalid');
      smsSubmit.disabled = true;
      const finish = () => { smsSubmit.disabled = false; if (giftMode) gamePhase = 'reveal'; show(finalStep); };
      const payload = JSON.stringify({ email: lastEmail || store.get('email') || '', phone, sms: true, mode: giftMode ? 'gift' : undefined, consentMode: smsConsent ? (smsConsent.defaultChecked ? 'precheck' : 'checkbox') : 'button' });
      const sync = () => fetch(d.smsUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: payload }).then((r) => r.json());
      // codul personal poate întârzia o clipă: reîncercăm de câteva ori în fundal, cât clientul vede deja pasul final
      const retry = (n) => setTimeout(() => sync().then((j) => { setPrize(j && j.prize); if (j && j.code) useCode(j.code); else if (n > 1) retry(n - 1); else {
        const pend = root.querySelector('[data-osm-pending]');
        if (pend) pend.textContent = 'Codul tău personal nu s-a putut genera acum. Reîncarcă pagina peste câteva secunde.';
      } }).catch(() => { if (n > 1) retry(n - 1); }), 2500);
      sync()
        .then((j) => {
          if (j && j.error === 'bad_phone') { smsSubmit.disabled = false; smsErr('Introdu un număr de telefon valid.'); return; }
          track('sms', { ok: !!(j && j.ok), sms: j && j.sms, error: j && j.error });
          setPrize(j && j.prize);
          if (j && j.code) useCode(j.code);
          else { const pend = root.querySelector('[data-osm-pending]'); if (pend) pend.hidden = false; retry(3); }
          finish();
        })
        .catch(() => { const pend = root.querySelector('[data-osm-pending]'); if (pend) pend.hidden = false; retry(3); finish(); });
    });

    /* ---------- Editor de temă ---------- */
    if (design) {
      if (timerEl) renderTimer(timerTotal);
      document.addEventListener('shopify:section:select', (e) => { if (e.detail.sectionId === sid) open(d.preview || firstStep, 'editor'); });
      document.addEventListener('shopify:section:deselect', (e) => { if (e.detail.sectionId === sid) close('editor'); });
      document.addEventListener('shopify:block:select', (e) => { if (e.detail.sectionId === sid) open(firstStep, 'editor'); });
      return;
    }

    /* ---------- Storefront ---------- */
    // Întoarcere după verificarea anti-spam Shopify
    const params = new URLSearchParams(location.search);
    // Vine dintr-un email/SMS SeveShop → e abonat; abonare din footer (?customer_posted=true fără popup) → la fel.
    const um = (params.get('utm_medium') || '').toLowerCase(), us = (params.get('utm_source') || '').toLowerCase();
    if (/^(email|e-mail|sms|newsletter)$/.test(um) || /themarketer|mktr|newsletter/.test(us)) markSubscriber();
    if (params.get('customer_posted') === 'true' && !store.get('pending')) markSubscriber();
    if (store.get('pending')) {
      const clean = (keys) => { try { keys.forEach((k) => params.delete(k)); history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params : '') + location.hash.replace('#osm-form', '')); } catch (e) {} };
      if (params.get('customer_posted') === 'true') {
        success();
        open(hasSms ? 'sms' : 'reveal', 'return');
        clean(['customer_posted']);
        return;
      }
      if (params.get('form_type') === 'customer' && params.has('contact[tags]')) {
        // Shopify s-a întors cu eroare (formularul retrimis cu datele lui) — redeschidem pe pasul cu emailul.
        store.del('pending');
        clean(['form_type', 'contact[tags]', 'contact[email]']);
        open('email', 'return');
        setError('Adresa nu a putut fi salvată. Verifică emailul și încearcă din nou.');
        return;
      }
      if (now() - (parseInt(store.get('pending'), 10) || 0) > 10 * 60 * 1000) store.del('pending');
    }

    const canAuto = () => test || !(store.get('done') || isSubscriber() || until('closed_until') > now() || until('expired_until') > now());
    const autoOpen = (how) => {
      if (autoShown || isOpen || !canAuto()) return;
      if (document.querySelector('dialog[open]')) {
        setTimeout(() => autoOpen(how), 4000);
        return;
      }
      autoShown = true;
      if (timerTotal && elapsed() >= timerTotal) store.del('elapsed');
      open(firstStep, how);
    };

    refreshTeaser();
    if (!canAuto()) return;

    const preload = () => root.querySelectorAll('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; });
    setTimeout(preload, Math.max(0, (parseInt(d.delay, 10) || 0) - 2) * 1000);
    setTimeout(() => autoOpen('delay'), (parseInt(d.delay, 10) || 0) * 1000);

    if (d.exit === 'true' && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const armedAt = now() + 3000;
      document.addEventListener('mouseout', (e) => {
        if (!e.relatedTarget && e.clientY <= 0 && now() > armedAt) autoOpen('exit');
      });
    }
  }

  // Pagina de verificare anti-spam Shopify (/challenge) randează tema: acolo popup-ul nu are voie să ruleze.
  const boot = () => { if (/^\/challenge/.test(location.pathname)) return; document.querySelectorAll('[data-osm]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
